import angular from 'angular';
import {
  ssDialogService,
  loaderService,
  eduDataService,
} from 'app/services';
import trainingAdminEditMediaDialog from './editMediaDialog';
import TrainingAdminMediaItemDirectiveController from './media-item.directive.controller';
import TrainingAdminMediaListDirectiveController from './media-list.directive.controller';
import trainingAdminMediaItem from './media-item.directive';
import trainingAdminMediaList from './media-list.directive';


require('angular-drag-and-drop-lists');

const dndLists = 'dndLists';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';

require('ng-file-upload/dist/ng-file-upload-shim');// Loads itself

export default angular.module('app.components.admin.trainingAdministration.media', [
  dndLists,
  eduDataService,
  ngFileUpload,
  loaderService,
  ssDialogService,
  trainingAdminEditMediaDialog,
])
  .directive('trainingAdminMediaItem', trainingAdminMediaItem)
  .controller('TrainingAdminMediaItemDirectiveController', TrainingAdminMediaItemDirectiveController)
  .directive('trainingAdminMediaList', trainingAdminMediaList)
  .controller('TrainingAdminMediaListDirectiveController', TrainingAdminMediaListDirectiveController)
  .name;

console.log('app.components.admin.trainingAdministration.media created');
